import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const bubbleSvgFn = /* @__PURE__ */ createRecipe('bubble-svg', {}, [])

const bubbleSvgVariantMap = {}

const bubbleSvgVariantKeys = Object.keys(bubbleSvgVariantMap)

export const bubbleSvg = /* @__PURE__ */ Object.assign(memo(bubbleSvgFn.recipeFn), {
  __recipe__: true,
  __name__: 'bubbleSvg',
  __getCompoundVariantCss__: bubbleSvgFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: bubbleSvgVariantKeys,
  variantMap: bubbleSvgVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, bubbleSvgVariantKeys)
  },
  getVariantProps: bubbleSvgFn.getVariantProps,
})